export default __webpack_public_path__ + "static/daygridyear-1a3c45658c064a9913406a778bf9792f.png";